import { appTypeConfig } from '../config'

const { allIndividualMenuFieldKeys = [] } = appTypeConfig

const PAIR_FIELDS = ['bvd', 'inset']

export const isOmegaFamilyAppType = () =>
  appTypeConfig.APP_TYPE === 'omega' || appTypeConfig.APP_TYPE === 'essilorsk'

export const isValueFilled = value => value || value === 0

export const isFieldRequired = conf =>
  conf === true || (typeof conf === 'object' && conf.isRequired === true)

export const isFieldShown = conf => typeof conf !== 'undefined'

export const getOrderKeys = field => {
  if (PAIR_FIELDS.includes(field)) {
    return [`${field}R`, `${field}L`]
  }
  return [field]
}

export const getCompareKeys = (field, fieldsValues = {}) => {
  const keys = getOrderKeys(field)
  if (field !== 'inset') return keys
  return keys.filter(key => {
    if (key === 'insetR') return fieldsValues.rightLensEnabled !== false
    if (key === 'insetL') return fieldsValues.leftLensEnabled !== false
    return true
  })
}

export const areLimitsOk = (conf, value) => {
  if (typeof conf !== 'object' || !conf) return true
  const { min, max, options } = conf
  if ((min || min === 0) && value < min) return false
  if ((max || max === 0) && value > max) return false
  if (options) {
    const optionValues = options.map(o => o.value ?? o)
    if (!optionValues.includes(value)) return false
  }
  return true
}

const nullOrderField = (order, field) => {
  getOrderKeys(field).forEach(key => {
    order[key] = null
  })
}

export const nullOmegaUnusedIndividualFields = (order, menuConf) => {
  allIndividualMenuFieldKeys.forEach(field => {
    if (!menuConf || !isFieldShown(menuConf[field])) {
      nullOrderField(order, field)
    }
  })
}

export const isOmegaIndividualMenuMustBeFilled = (menuConf, fieldsValues) => {
  if (!menuConf) return false
  return allIndividualMenuFieldKeys.some(field => {
    const conf = menuConf[field]
    if (!isFieldRequired(conf)) return false
    return getCompareKeys(field, fieldsValues).some(key => {
      const value = fieldsValues[key]
      return !isValueFilled(value) || !areLimitsOk(conf, value)
    })
  })
}

export const isOmegaIndividualMenuValuesLost = (currentMenuConf, newMenuConf, fieldsValues) => {
  if (!currentMenuConf || !newMenuConf) return false
  return allIndividualMenuFieldKeys.some(field => {
    const hasFilledValue = getCompareKeys(field, fieldsValues).some(key =>
      isValueFilled(fieldsValues[key]),
    )
    if (!hasFilledValue) return false
    const newConf = newMenuConf[field]
    if (!isFieldShown(newConf)) return true
    return getCompareKeys(field, fieldsValues).some(key => {
      const value = fieldsValues[key]
      return isValueFilled(value) && !areLimitsOk(newConf, value)
    })
  })
}
